import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { EditSponsorsForm } from 'local/components'
import { Button, ContentLoader, Input, Margin, Text } from 'shared/components'

import * as styles from './styles'

const SponsorsUpdateComponent = ({
  onSubmit,
  getSponsorInfoById,
  sponsorId,
  getLinkForSponsorConfirmSignUp,
}) => {
  const [initialValues, setInitialValues] = useState('')
  const [link, handleLinkGenerate] = useState('')

  useEffect(() => {
    const getData = async () => {
      const sponsorInfo = await getSponsorInfoById(sponsorId)
      setInitialValues({
        ...sponsorInfo,
      })
    }
    getData()
  }, [])

  const handleClickGenerateLink = async () => {
    const link = await getLinkForSponsorConfirmSignUp(
      initialValues.preRegistrationId
    )
    handleLinkGenerate(link)
  }

  return initialValues ? (
    <>
      <EditSponsorsForm
        header="Update Sponsor"
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
      {!initialValues.active && (
        <>
          <Margin top={2} bottom={3} left={2}>
            <Text size={16} bold>
              Generate SignUp Confirm Link
            </Text>
          </Margin>
          <Margin top={2} bottom={3} left={2}>
            <Text size={16} bold>
              Pre Registration Id: {initialValues.preRegistrationId}
            </Text>
          </Margin>
          <Margin top={2} bottom={2} left={2}>
            <Input value={link} placeholder="Generate Link first..." />
          </Margin>
          <Margin left={2} bottom={3}>
            <Button green="true" medium onClick={handleClickGenerateLink}>
              Generate Link
            </Button>
          </Margin>
        </>
      )}
    </>
  ) : (
    <div css={styles.loaderWrapper}>
      <ContentLoader loading={true} />
    </div>
  )
}

SponsorsUpdateComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getLinkForSponsorConfirmSignUp: PropTypes.func.isRequired,
  getSponsorInfoById: PropTypes.any,
  sponsorId: PropTypes.any,
}

export default SponsorsUpdateComponent
